// The six Fable + "worlds" (service verticals). Ported from the mobile design tokens
// (src/theme/tokens.ts MODULES) so web and mobile share one identity.
import { Scissors, GraduationCap, KeyRound, UtensilsCrossed, Clapperboard, Ticket } from "lucide-react";

export const WORLDS = [
  {
    key: "services",
    name: "Services",
    accent: "#0A84FF",
    accentSoft: "#E0EDFF",
    icon: Scissors,
    tagline: "Book trusted local pros",
    searchPlaceholder: "What service do you need?",
  },
  {
    key: "experiences",
    name: "Experiences",
    accent: "#00C2E0",
    accentSoft: "#D6F7FC",
    icon: Ticket,
    tagline: "Book unforgettable activities",
    searchPlaceholder: "What do you want to do?",
  },
  {
    key: "food",
    name: "Food",
    accent: "#FF5722",
    accentSoft: "#FFE5DB",
    icon: UtensilsCrossed,
    tagline: "Homemade, made with love",
    searchPlaceholder: "What are you craving?",
  },
  {
    key: "education",
    name: "Education",
    accent: "#FFB800",
    accentSoft: "#FFF2CC",
    icon: GraduationCap,
    tagline: "Learn from expert instructors",
    searchPlaceholder: "What do you want to learn?",
  },
  {
    key: "rentals",
    name: "Rentals",
    accent: "#FF1493",
    accentSoft: "#FFE0F0",
    icon: KeyRound,
    tagline: "Rent anything, anytime",
    searchPlaceholder: "What do you want to rent?",
  },
  {
    key: "casting",
    name: "Casting",
    accent: "#8E24FF",
    accentSoft: "#EEE0FF",
    icon: Clapperboard,
    tagline: "Collaborate & create together",
    searchPlaceholder: "Find talent or projects…",
  },
];

export const WORLD_MAP = WORLDS.reduce((acc, w) => ({ ...acc, [w.key]: w }), {});

export function worldOf(key) {
  return WORLD_MAP[key] || WORLDS[0];
}
